<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'ModuleArticlesAggregatorSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    categories: []
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

onBeforeMount((): void =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Kategorię]]]')" :invalid-feedback="form.$errors.first('settings.categories')" :state="form.$errors.state('settings.categories')">
        <EditoArticleCategories v-model="form.settings.categories" />
    </IdeoFormGroup>
</template>
